<template>
  <section id="drivers">
    <h2>{{ $t("sections.drivers.title") }}</h2>
    <ServiceOrigami animal="bird" :fill="origamiFillColor" />
    <ol>
        <!-- @click.stop="driver.isExpanded = !driver.isExpanded"
         -->
      <li
        v-for="(driver, index) in drivers"
        :key="index"
        @click="expand($event, index)"
        class="accordion-item"
        :class="{ 'is-open': driver.isExpanded}"
        ref="driver"
      >
        <header>
          <h3>{{driver.name}}</h3>
        </header>
        <article
          :ref="'accordion-body-' + index">
            <p>{{driver.desc}}</p>
        </article>
      </li>
    </ol>
  </section>
</template>

<script>

import { TweenLite, Elastic, Bounce } from 'gsap'
import ServiceOrigami from "../components/origami/ServicesOrigami";

export default {
  components: {
    ServiceOrigami
  },
  data() {
    return {
      drivers: [
        {
          name: this.$t("sections.drivers.elements[0].name"),
          desc: this.$t("sections.drivers.elements[0].desc"),
          isExpanded: false
        },
        {
          name: this.$t("sections.drivers.elements[1].name"),
          desc: this.$t("sections.drivers.elements[1].desc"),
          isExpanded: false
        },
        {
          name: this.$t("sections.drivers.elements[2].name"),
          desc: this.$t("sections.drivers.elements[2].desc"),
          isExpanded: false
        }
      ],
      selectedDriver: "default"
    };
  },
  computed: {
    origamiFillColor: function() {
      switch (this.selectedDriver) {
        case "default":
          return ["#25BCCA", "#1A9DAE", "#0E687A"];

        default:
          return ["#1A9DAE", "#25BCCA", "#0E687A"];
      }
    }
  },
  methods: {
		expand: function(e, i) {
			e.preventDefault();

      let el = this.$refs['accordion-body-' + i][0];

			if (this.drivers[i].isExpanded === false) {
				this.drivers[i].isExpanded = true;

				TweenLite.to(el, 1, {
					height: el.scrollHeight,
					ease: Elastic.easeOut.config(1, 0.3)
				});
			} else {
				this.drivers[i].isExpanded = false;

				TweenLite.to(el, 0.5, {
					height: 0,
					ease: Elastic.easeOut.config(0.3, 1)
				});
			}
		}
	},
};
</script>


<style lang="scss" scoped>
@import "../styles/_mixins.scss";

section {
  padding-top: $large_vmin;

  @include respond-to(tablet) {
    @include grid(12);
    grid-column-gap: 0;
    padding-top: 0;
  }

  h2 {
    text-align: center;
    padding-bottom: $large_vmin;

    @include respond-to(tablet) {
      text-align: left;
      grid-column: 5 / span 7;
    }

    @include respond-to(desktop) {
      font-size: 3.25rem;
      font-weight: bold;
      @include grid--half-dx;
    }
  }

  figure {
    position: relative;
    max-width: 75vw;
    margin: 0 auto;
    z-index: $z_index_max;

    @include respond-to(tablet) {
      grid-column: 1 / span 4;
      transform: translateY(5rem);
      grid-row: 1 / span 4;
      margin: 0;
    }

    @include respond-to(desktop) {
      grid-column: 2 / span 5;
      transform: translate(-5rem, 5rem);
    }

    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 40%;
      width: 5px;
      height: 90%;
      transform: translate(0, -80%) rotate(40deg);
      background: $gray_light_2;
      z-index: 0;
    }

    &:after {
      content: "~";
      position: absolute;
      font-size: $large_vmin;
      top: 0;
      left: 0;
      color: $secondary;
      z-index: 0;
    }
  }

  ol {
    padding-left: 0;
    counter-reset: driver;
    grid-column: 1 / span 12;
    grid-row: 2 / span 3;

    li {
      padding: $default_vmin 0;
      cursor: pointer;
      @include grid-padding;
      position: relative;

      &:after {
        content: "+";
        width: 25px;
        height: 25px;
        top: 0;
        font-size: 5vmin;
        color: $secondary;
        position: absolute;
        right: 2.5vmin;
        opacity: .5;
      }

      article {
        height: 0;
        overflow: hidden;
        
      }

      @include respond-to(tablet) {
        @include grid(12);
        align-items: center;
        padding-left: 0;
        padding-right: 0;
      }


        &.is-open  {
          article {
            padding: $large_vmin 0;

            @include respond-to(tablet) {
              padding: $small_vmin 0;
            }
          }
          
          &:after {
            content: '-';
          }
        }

      &:nth-of-type(2) {
        background-color: $gray_light_1;

        h3 {
          &:after {
            background-color: $gray_dark_4;
          }
        }
      }

      &:nth-of-type(3) {
        background-color: $gray_dark_4;

        h3 {
          color: $gray_light_1;
          &:after {
            background-color: $gray_light_1;
          }
        }
      }

      &:last-of-type {

        &:after {
          color: white;
        }
        
        header {
          color: $gray_light_1;

          h3 {
            &:after {
              background-color: $gray_light_1;
            }
          }
        }
        > article {

          p {
            color: $gray_light_1;
          }
        }
      }

      &:hover {
        h3 {
          opacity: 0.8;

          &:after {
            width: 100%;
          }
        }
      }

      h3 {
        display: inline-block;
        position: relative;

        &:before {
          counter-increment: driver; /* Increment the value of service counter by 1 */
          content: "0" counter(driver) ""; /* Display the word 'service ', the value of service counter, and a colon before the content of each a tag */
          font-size: 70%;
          padding-right: $small_vmin;
        }

        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          width: 8%;
          left: 0;
          transform: translate(0, 5px);
          height: 3px;
          background-color: $gray_dark_4;
          transition: width 1s cubic-bezier(0, -0.01, 1, 1.45);
        }
      }

      header,
      article{
        @include respond-to(tablet) {
          grid-column: 5 / span 7;
        }

        @include respond-to(desktop) {
          grid-column: 7 / span 5;
        }
      }

      article {
        // padding: $large_vmin 0;
        text-align: left;

        @include respond-to(tablet) {
          // padding: $small_vmin 0;
        }
      }
    }
  }
}

</style>

